<template>
  <index-content>
    <template #options>
      <nb-download :url="CSV_URL" :params="condition" />
      <nb-sort v-model="sortable" />
      <nb-add @on-click="openModal" />
    </template>
    <search-condition>
      <ns-company v-model="condition.companyId" @on-change="load" />
    </search-condition>
    <div class="table-responsive">
      <table class="table table-striped table-bordered table-hover text-center n-table">
        <thead>
          <tr>
            <th>{{ $t('label.id') }}</th>
            <th>{{ $t('label.company') }}</th>
            <th>{{ $t('label.name') }}</th>
            <th>{{ $t('label.parent') }}</th>
            <th class="image">{{ $t('label.icon') }}</th>
            <th>{{ $t('label.type') }}</th>
            <th>{{ $t('label.readonly') }}</th>
            <th class="n-table-timestamp">{{ $t('label.lastUpdate') }}</th>
            <th v-table-action class="action-edit">{{ $t('label.action') }}</th>
          </tr>
        </thead>
        <n-draggable v-model="records" :disabled="!sortable" @on-change="onDropped">
          <tr v-for="row in records" :key="row.id" :class="{ 'n-table-sortable': sortable }">
            <td>{{ row.id }}</td>
            <td v-selection:[`company.company`]="row.companyId"></td>
            <td>{{ row.name }}</td>
            <td v-selection:[`company.category`]="row.parentId"></td>
            <td><n-image :image-id="row.icon" :type="ImageType.ICON" :title="row.name" :width="30" :height="30" /></td>
            <td v-enums:TransactionType="row.type"></td>
            <td><n-icon-boolean :value="row.readonly" /></td>
            <td>{{ row.updateDatetime | datetime }}</td>
            <td class="n-button-box"><nb-modal @on-click="openModal(row)"></nb-modal></td>
          </tr>
        </n-draggable>
      </table>
    </div>
  </index-content>
</template>

<script>
import BaseCompanyView from './view';
import DndMixin from '@/mixins/dnd-mixin';
import { ImageType } from '@/constant/enums';
import ModalCompanyCategory from './ModalCompanyCategory';
import { CSV_URL, sort, fetch } from '@/api/company/company-category';

export default BaseCompanyView.extend({
  name: 'CompanyCategory',
  mixins: [DndMixin],

  data() {
    return {
      ImageType,
      CSV_URL,
      preload: true,
      sortable: false,
      condition: {
        companyId: 0,
      },
    };
  },

  methods: {
    doLoad() {
      return fetch({
        companyId: this.condition.companyId,
      });
    },

    parse(data) {
      this.records = data;
    },

    doDrop(list) {
      return sort({ ...this.condition, categoryIds: list.map(r => r.id).join(',') });
    },

    openModal(model = {}) {
      this.createModal(ModalCompanyCategory, { model, on: this });
    },
  },
});
</script>
